/**
 * Only for a person who was signed in: before then a 403
 * REGISTRATION_REQUIRED is the expected answer for a policyholder who has not
 * registered here yet, and the sign-in screens handle it themselves.
 */
const sessionLost = (error) => {
  const status = error?.response?.status;

  return status === 401 || (status === 403 && error.response.data?.code === 'REGISTRATION_REQUIRED');
};

export function signOutOnLostSession(http, authStore, goToSignIn) {
  let signingOut = false;

  return http.interceptors.response.use(undefined, async (error) => {
    if (!signingOut && authStore.userData && sessionLost(error)) {
      signingOut = true;
      await authStore.logout();
      goToSignIn();
    }

    return Promise.reject(error);
  });
}
